import React, { useState, FunctionComponent } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { Formik, Form } from "formik";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import { IconButton, Snackbar, SnackbarContent, CircularProgress } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ErrorOutlineRoundedIcon from "@material-ui/icons/ErrorOutlineRounded";
import { useItemReturnStyles } from "../useItemReturnStyles";

type AuthenticationDialogProps = {
  openAuthenticationDialog: boolean;
  handleCloseAuthenticationDialog: () => void;
  onAuthenticationCheck: (crendentials: any) => any;
};
export const AuthenticationDialog: FunctionComponent<
  AuthenticationDialogProps
> = ({
  openAuthenticationDialog,
  handleCloseAuthenticationDialog,
  onAuthenticationCheck,
}) => {
  const classes = useItemReturnStyles();
  const [notAuthorised, setNotAuthorised] = useState(false);
  const [error, setError] = useState<any>(null);
  const [authenticationLoading, setAuthenticationLoading] = useState<
    boolean
  >(false);
  const NavLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(
    (props, ref) => <RouterLink innerRef={ref} {...props} />
  );
  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={!!error}
        autoHideDuration={2000}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        onClose={() => setError(null)}
      >
        <SnackbarContent
          style={{ backgroundColor: "red" }}
          message={
            <span
              id="message-id"
              style={{
                display: "flex",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <ErrorOutlineRoundedIcon />
              {error}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="close"
              onClick={() => setError(null)}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
      <Dialog open={openAuthenticationDialog}>
        <Formik
          enableReinitialize
          initialValues={{
            username: "",
            password: "",
          }}
          onSubmit={async (values) => {
            try {
              setAuthenticationLoading(true);
              let credentialResult = await onAuthenticationCheck(values);
              // try {
              //   const permissionObject={
              //     username:values.username,
              //     password:values.password,
              //     privilege:"item-return",
              //     action:"edit"
              //   }
              //   let credentialResult = await api.post(
              //     `item-return/verify-permission`,
              //     {},
              //     permissionObject
              //   );
              if (credentialResult === true) {
                setAuthenticationLoading(false);
                handleCloseAuthenticationDialog();
              } else if (credentialResult.message) {
                setAuthenticationLoading(false);
                setError(credentialResult.message);
              } else {
                setError("Something went wrong");
                setAuthenticationLoading(false);
              }
            } catch (error:any) {
              setError(error.error);
              setAuthenticationLoading(false);
            }
          }}
        >
          {({ values, handleChange }) => (
            <Form autoComplete="off">
              <DialogContent>
                <DialogContentText>
                  Please enter your username and password
                </DialogContentText>

                <TextField
                  required
                  margin="dense"
                  name="username"
                  variant="outlined"
                  onChange={handleChange}
                  value={values.username}
                  label="User Name"
                  type="name"
                  fullWidth
                />
                <TextField
                  required
                  margin="dense"
                  name="password"
                  variant="outlined"
                  onChange={handleChange}
                  value={values.password}
                  label="Password"
                  type="password"
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <Button type="submit" variant="contained" color="primary" disabled={authenticationLoading}>
                  Submit
                </Button>
                {authenticationLoading && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonauthenticationProgress}
                  />
                )}
                <Button
                  onClick={handleCloseAuthenticationDialog}
                  component={NavLink}
                  to={`/`}
                  variant="contained"
                  color="primary"
                >
                  Cancel
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
      {notAuthorised ? (
        <div>
          <Dialog
            open={notAuthorised}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                You are not authorised for this action
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setNotAuthorised(false)}
                component={NavLink}
                to={`/`}
              >
                ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
